import React from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { formatDate } from '../../../../utilities/DateUtil';
import { Button } from 'primereact/button';
import { abrirCotizacionPDF } from '../../../../service/AffariService';



export const HistoriaDialog = ({ visible, onCancel, data }) => {
    return (
        <Dialog 
            header={`Historia de Cotización`} 
            visible={visible} 
            style={{ width: '80vw' }} 
            onHide={onCancel}
        >
            <DataTable 
                value={data} 
                size="small" 
                stripedRows 
                showGridlines
            >
                <Column 
                    header="#" 
                    body={(rowData) => (
                        <>
                            <Button 
                                icon="pi pi-file" 
                                tooltip="Ver" 
                                tooltipOptions={{ position: 'top' }} 
                                text 
                                className="p-button-sm p-0 w-1rem ml-2" 
                                onClick={() => {
                                    abrirCotizacionPDF(rowData.id);
                                }}
                            />
                        </>
                    )} 
                />
                <Column field="folio" header="Folio" sortable></Column>
                <Column 
                    header="Cliente"
                    body={(rowData) => (
                        <div className="flex flex-column">
                            <span className="ml-2">{rowData.cliente.codigo} {rowData.cliente.razonSocial}</span>
                        </div>
                    )} 
                    sortable
                />
                <Column field="cliente.vendedor.descripcion" header="Vendedor" sortable></Column>
                <Column field="fecha" header="Fecha" body={(rowData) => formatDate(rowData.fecha)} sortable></Column>
                <Column field="total" header="Total" body={(rowData) => `${rowData.total}`} sortable></Column>
                <Column field="estado.descripcion" header="Estado" sortable></Column>
            </DataTable>
        </Dialog>
    );
};